import { defineStore } from 'pinia'
import { ref } from 'vue'
import api from '@/utils/api'
import { API_ROUTES } from '@/const/apiRoutes'

interface Country {
  label: string;
  value: number;
}

export const useCountryStore = defineStore('country', () => {
  const countries = ref<Country[]>([])
  const fellowCountries = ref<Country[]>([])
  const isLoading = ref(false)
  const error = ref<string | null>(null)

  const fetchCountries = async () => {
    isLoading.value = true
    error.value = null
    
    try {
      const response = await api.get(API_ROUTES.GET_COUNTRIES)
      countries.value = response.data.map((country: any) => ({
        label: country.country_name,
        value: country.id
      }))
      return countries.value
    } catch (err: any) {
      error.value = err.response?.data?.message || 'Failed to fetch countries'
      throw err
    } finally {
      isLoading.value = false
    }
  }

  const fetchFellowCountries = async () => {
    isLoading.value = true
    error.value = null
    
    try {
      const response = await api.get(API_ROUTES.GET_COUNTRIES, {
        params: {
          only_fellow_countries: true
        }
      })
      fellowCountries.value = response.data.map((country: any) => ({
        label: country.country_name,
        value: country.id
      }))
      return fellowCountries.value
    } catch (err: any) {
      error.value = err.response?.data?.message || 'Failed to fetch fellow countries'
      throw err
    } finally {
      isLoading.value = false
    }
  }

  return {
    countries,
    fellowCountries,
    isLoading,
    error,
    fetchCountries,
    fetchFellowCountries
  }
})

export type { Country }
